import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class ImageHelperService {
    constructor(private sanitizer: DomSanitizer) {}

    getSafeImage(base64Data: string, mimeType = 'image/jpeg'): SafeUrl {
        // Ensure we have the prefix
        const header = `data:${mimeType};base64,`;
        const dataUri = base64Data.startsWith('data:')
            ? base64Data
            : header + base64Data;
        // Bypass Angular’s security to allow this image URL
        return this.sanitizer.bypassSecurityTrustUrl(dataUri);
    }

    getImageHelper$(): Observable<{}> {
        return of({});
    }
}
